import { Component, HostListener, Input, OnInit } from "@angular/core";
import {
  trigger,
  state,
  style,
  transition,
  animate
} from "@angular/animations";
import {
  BrowserAnimationsModule,
  NoopAnimationsModule
} from "@angular/platform-browser/animations";

@Component({
  selector: "pru-backtotop",
  templateUrl: "back-to-top.component.html",
  styleUrls: ["./back-to-top.component.scss"],
  animations: [
    trigger("appearInOut", [
      state(
        "in",
        style({
          display: "block",
          opacity: "1"
        })
      ),
      state(
        "out",
        style({
          display: "none",
          opacity: "0"
        })
      ),
      transition("in => out", animate("400ms ease-in-out")),
      transition("out => in", animate("400ms ease-in-out"))
    ])
  ]
})
export class BackToTopComponent implements OnInit {
  animationState: string = "out";
  private timerID: any = null;
  @Input() scrollDistance: number = 100;
  @Input() animate: boolean = false;
  @Input() speed: number = 10;
  @Input() acceleration: number = 0;

  ngOnInit() {
    this.validateInputs();
  }

  private validateInputs() {
    let errorMessagePrefix = "BackToTop Component input validation error: ";
    if (this.scrollDistance < 0) {
      throw Error(
        errorMessagePrefix +
          "BackToTopComponent 'scrollDistance' parameter must be greater or equal to 0"
      );
    }
    if (this.speed < 1) {
      throw Error(
        errorMessagePrefix +
          "BackToTopComponent 'speed' parameter must be a positive number"
      );
    }
    if (this.acceleration < 0) {
      throw Error(
        errorMessagePrefix +
          "BackToTopComponent 'acceleration' parameter must be greater or equal to 0"
      );
    }
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (this.isBrowser()) {
      this.animationState =
        this.getCurrentScrollTop() > this.scrollDistance ? "in" : "out";
    }
  }

  scrollTop(event: any) {
    if (!this.isBrowser()) {
      return;
    }
    event.preventDefault();
    if (this.animate) {
      this.animateScrollTop();
    } else {
      window.scrollTo(0, 0);
    }
  }

  animateScrollTop() {
    if (this.timerID !== null) {
      return;
    }
    let initialSpeed = this.speed;
    let that = this;
    this.timerID = setInterval(function() {
      window.scrollBy(0, -initialSpeed);
      initialSpeed = initialSpeed + that.acceleration;
      if (that.getCurrentScrollTop() === 0) {
        clearInterval(that.timerID);
        that.timerID = null;
      }
    }, 15);
  }

  getCurrentScrollTop() {
    if (typeof window.scrollY !== "undefined" && window.scrollY >= 0) {
      return window.scrollY;
    }
    if (typeof window.pageYOffset !== "undefined" && window.pageYOffset >= 0) {
      return window.pageYOffset;
    }
    if (
      typeof document.body.scrollTop !== "undefined" &&
      document.body.scrollTop >= 0
    ) {
      return document.body.scrollTop;
    }
    if (
      typeof document.documentElement.scrollTop !== "undefined" &&
      document.documentElement.scrollTop >= 0
    ) {
      return document.documentElement.scrollTop;
    }
    return 0;
  }

  isBrowser(): boolean {
    return typeof window !== "undefined";
  }
}
